export default __webpack_public_path__ + "images/default-profile-picture-2.webp";